module.exports = __webpack_public_path__ + "img/hero.16073576.jpg";